import { Data } from '../../../models/index';
import { UseCase } from '../../UseCase';

export class GetDataLevel implements UseCase<Data, string | undefined> {
    execute(data: Data): string | undefined {
        return data.level;
    }
}
